import { render, staticRenderFns } from "./VehicleModal.vue?vue&type=template&id=3295cc44&"
import script from "./VehicleModal.vue?vue&type=script&lang=ts&"
export * from "./VehicleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports